import { defineComponent as z, inject as R, computed as s, ref as G, provide as J, h as r, mergeProps as Q, Transition as W } from "vue";
import X from "./ghl-ui.es954.js";
import { dropdownInjectionKey as Y, dropdownOptionInjectionKey as D, dropdownMenuInjectionKey as Z } from "./ghl-ui.es956.js";
import { popoverBodyInjectionKey as ee } from "./ghl-ui.es1305.js";
import { isSubmenuNode as ne } from "./ghl-ui.es1316.js";
import { useDeferredTrue as oe } from "./ghl-ui.es1448.js";
import $ from "./ghl-ui.es680.js";
import { render as O } from "./ghl-ui.es944.js";
import { NIcon as te } from "./ghl-ui.es979.js";
import re from "./ghl-ui.es905.js";
import { happensIn as _ } from "./ghl-ui.es903.js";
import de from "./ghl-ui.es878.js";
import ie from "./ghl-ui.es879.js";
import le from "./ghl-ui.es880.js";
const Se = z({
  name: "DropdownOption",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    tmNode: {
      type: Object,
      required: !0
    },
    parentKey: {
      type: [String, Number],
      default: null
    },
    placement: {
      type: String,
      default: "right-start"
    },
    props: Object,
    scrollable: Boolean
  },
  setup(t) {
    const l = R(Y), {
      hoverKeyRef: c,
      keyboardKeyRef: d,
      lastToggledSubmenuKeyRef: v,
      pendingKeyPathRef: o,
      activeKeyPathRef: y,
      animatedRef: w,
      mergedShowRef: u,
      renderLabelRef: g,
      renderIconRef: N,
      labelFieldRef: f,
      childrenFieldRef: P,
      renderOptionRef: S,
      nodePropsRef: p,
      menuPropsRef: K
    } = l, i = R(D, null), m = R(Z), I = R(ee), j = s(() => t.tmNode.rawNode), M = s(() => {
      const {
        value: e
      } = P;
      return ne(t.tmNode.rawNode, e);
    }), B = s(() => {
      const {
        disabled: e
      } = t.tmNode;
      return e;
    }), E = s(() => {
      if (!M.value)
        return !1;
      const {
        key: e,
        disabled: n
      } = t.tmNode;
      if (n)
        return !1;
      const {
        value: a
      } = c, {
        value: h
      } = d, {
        value: U
      } = v, {
        value: b
      } = o;
      return a !== null ? b.includes(e) : h !== null ? b.includes(e) && b[b.length - 1] !== e : U !== null ? b.includes(e) : !1;
    }), F = s(() => d.value === null && !w.value), T = oe(E, 300, F), A = s(() => !!(i != null && i.enteringSubmenuRef.value)), k = G(!1);
    J(D, {
      enteringSubmenuRef: k
    });
    function C() {
      k.value = !0;
    }
    function L() {
      k.value = !1;
    }
    function x() {
      const {
        parentKey: e,
        tmNode: n
      } = t;
      n.disabled || u.value && (v.value = e, d.value = null, c.value = n.key);
    }
    function H() {
      const {
        tmNode: e
      } = t;
      e.disabled || u.value && c.value !== e.key && x();
    }
    function V(e) {
      if (t.tmNode.disabled || !u.value)
        return;
      const {
        relatedTarget: n
      } = e;
      n && !_({
        target: n
      }, "dropdownOption") && !_({
        target: n
      }, "scrollbarRail") && (c.value = null);
    }
    function q() {
      const {
        value: e
      } = M, {
        tmNode: n
      } = t;
      u.value && !e && !n.disabled && (l.doSelect(n.key, n.rawNode), l.doUpdateShow(!1));
    }
    return {
      labelField: f,
      renderLabel: g,
      renderIcon: N,
      siblingHasIcon: m.showIconRef,
      siblingHasSubmenu: m.hasSubmenuRef,
      menuProps: K,
      popoverBody: I,
      animated: w,
      mergedShowSubmenu: s(() => T.value && !A.value),
      rawNode: j,
      hasSubmenu: M,
      pending: $(() => {
        const {
          value: e
        } = o, {
          key: n
        } = t.tmNode;
        return e.includes(n);
      }),
      childActive: $(() => {
        const {
          value: e
        } = y, {
          key: n
        } = t.tmNode, a = e.findIndex((h) => n === h);
        return a === -1 ? !1 : a < e.length - 1;
      }),
      active: $(() => {
        const {
          value: e
        } = y, {
          key: n
        } = t.tmNode, a = e.findIndex((h) => n === h);
        return a === -1 ? !1 : a === e.length - 1;
      }),
      mergedDisabled: B,
      renderOption: S,
      nodeProps: p,
      handleClick: q,
      handleMouseMove: H,
      handleMouseEnter: x,
      handleMouseLeave: V,
      handleSubmenuBeforeEnter: C,
      handleSubmenuAfterEnter: L
    };
  },
  render() {
    var t, l;
    const {
      animated: c,
      rawNode: d,
      mergedShowSubmenu: v,
      clsPrefix: o,
      siblingHasIcon: y,
      siblingHasSubmenu: w,
      renderLabel: u,
      renderIcon: g,
      renderOption: N,
      nodeProps: f,
      props: P,
      scrollable: S
    } = this;
    let p = null;
    if (v) {
      const I = (t = this.menuProps) === null || t === void 0 ? void 0 : t.call(this, d, d.children);
      p = r(X, Object.assign({}, I, {
        clsPrefix: o,
        scrollable: this.scrollable,
        tmNodes: this.tmNode.children,
        parentKey: this.tmNode.key
      }));
    }
    const K = {
      class: [`${o}-dropdown-option-body`, this.pending && `${o}-dropdown-option-body--pending`, this.active && `${o}-dropdown-option-body--active`, this.childActive && `${o}-dropdown-option-body--child-active`, this.mergedDisabled && `${o}-dropdown-option-body--disabled`],
      onMousemove: this.handleMouseMove,
      onMouseenter: this.handleMouseEnter,
      onMouseleave: this.handleMouseLeave,
      onClick: this.handleClick
    }, i = f == null ? void 0 : f(d), m = r("div", Object.assign({
      class: [`${o}-dropdown-option`, i == null ? void 0 : i.class],
      "data-dropdown-option": !0
    }, i), r("div", Q(K, P), [r("div", {
      class: [`${o}-dropdown-option-body__prefix`, y && `${o}-dropdown-option-body__prefix--show-icon`]
    }, [g ? g(d) : O(d.icon)]), r("div", {
      "data-dropdown-option": !0,
      class: `${o}-dropdown-option-body__label`
    }, u ? u(d) : O((l = d[this.labelField]) !== null && l !== void 0 ? l : d.title)), r("div", {
      "data-dropdown-option": !0,
      class: [`${o}-dropdown-option-body__suffix`, w && `${o}-dropdown-option-body__suffix--has-submenu`]
    }, this.hasSubmenu ? r(te, null, {
      default: () => r(re, null)
    }) : null)]), this.hasSubmenu ? r(de, null, {
      default: () => [r(ie, null, {
        default: () => r("div", {
          class: `${o}-dropdown-offset-container`
        }, r(le, {
          show: this.mergedShowSubmenu,
          placement: this.placement,
          to: S && this.popoverBody || void 0,
          teleportDisabled: !S
        }, {
          default: () => r("div", {
            class: `${o}-dropdown-menu-wrapper`
          }, c ? r(W, {
            onBeforeEnter: this.handleSubmenuBeforeEnter,
            onAfterEnter: this.handleSubmenuAfterEnter,
            name: "fade-in-scale-up-transition",
            appear: !0
          }, {
            default: () => p
          }) : p)
        }))
      })]
    }) : null);
    return N ? N({
      node: m,
      option: d
    }) : m;
  }
});
export {
  Se as default
};
